import { getCsrfToken } from "../utils/csrf.util"
import { rethrowUnlessAbort } from "../utils/fetch-error.util"

function assertOk(response) {
  if (!response.ok) throw new Error(`Guide request failed: HTTP ${response.status}`)

  return response
}

// Saves guide progress. `keepalive` lets the request finish even when the click that triggered it navigates
// away in the same tick (a Turbo visit), which is the point of saving on click.
//
// A failed save must never break the tour, so the promise returned here always resolves. The failure itself is
// not hidden: it is re-raised on a detached branch, where the global handler (monitoring) sees it. An abort
// (the page leaving) is not a failure.
export function postGuide(url, body = {}) {
  const request = fetch(url, {
    method: "POST",
    keepalive: true,
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-CSRF-Token": getCsrfToken()
    },
    body: JSON.stringify(body)
  }).then(assertOk)

  request.catch(rethrowUnlessAbort)
  return request.catch(() => {})
}
